import { PropsWithChildren } from 'react';

import { Box } from '@chakra-ui/react';

import { EventType } from '~/components/Event';
import UserMenu from '~/components/User/UserMenu';

import Header, { IHeaderProps } from './Header';
export const MAX_WIDTH = '1440px';

type LayoutProps = PropsWithChildren & {
    fullWidth?: boolean;
    event?: EventType;
    appName?: string;
    headerProps?: Partial<IHeaderProps>;
};

const Layout: React.FunctionComponent<LayoutProps> = ({
    fullWidth = true,
    event,
    appName,
    children,
    headerProps
}) => {
    return (
        <>
            <Box borderBottom="2px solid" borderBottomColor="gray.200">
                <Header
                    appName={appName}
                    userMenu={<UserMenu event={event} />}
                    maxW={MAX_WIDTH}
                    {...headerProps}
                ></Header>
            </Box>
            <Box maxW={fullWidth ? '100%' : MAX_WIDTH} mx="auto">
                {children}
            </Box>
        </>
    );
};

export default Layout;
